export const heroBadges = ["线索反映", "提供信息", "配合核查", "群防群治"];

export const quickStats = [
  { label: "主要受理方向", value: "治安类", note: "隐患线索为主" },
  { label: "推荐上报速度", value: "及时", note: "发现即反映" },
  { label: "信息要点", value: "五要素", note: "时地人事物" },
  { label: "核查方式", value: "电话回访", note: "依法保密" },
];

export const channelCards = [
  {
    icon: "ri-shield-check-line",
    tone: "primary",
    title: "向属地派出所反映",
    desc: "居住地附近的治安隐患、可疑人员与秩序问题，可就近向社区民警和属地派出所反映，便于及时核查处理。",
    tags: ["治安", "可走访", "就近"],
  },
  {
    icon: "ri-customer-service-2-line",
    tone: "accent",
    title: "政务服务热线",
    desc: "涉及公共事务、政务服务或政策咨询类问题，可通过政府服务热线进行反映，转办至对应职能部门跟进。",
    tags: ["政务", "电话", "转办"],
  },
  {
    icon: "ri-building-line",
    tone: "secondary",
    title: "社区居委联络",
    desc: "向所在社区居委会、楼门长或网格员说明情况，通过基层治理网络把问题接入正规处理流程，实现早发现早处置。",
    tags: ["社区", "网格", "基层"],
  },
  {
    icon: "ri-focus-3-line",
    tone: "primary",
    title: "实名现场登记",
    desc: "对需要后续回访或核查的事项，可在工作人员指引下进行实名登记，留存联系方式以便反馈处理进展。",
    tags: ["实名", "登记", "回访"],
  },
];

export const guideSteps = [
  {
    step: "01",
    icon: "ri-eye-2-line",
    title: "先观察核实",
    desc: "对观察到的情况先冷静判断，尽量确认时间、地点与基本事实，避免因信息不清导致误报。",
  },
  {
    step: "02",
    icon: "ri-file-list-3-line",
    title: "整理五要素",
    desc: "按“时间、地点、人物、事件、现场情况”五个要素整理线索，信息越具体越便于核查。",
  },
  {
    step: "03",
    icon: "ri-send-plane-line",
    title: "选择正规渠道",
    desc: "优先通过属地公安、政务热线、社区居委等官方途径提交，不要轻信来源不明的“举报链接”。",
  },
  {
    step: "04",
    icon: "ri-lock-2-line",
    title: "如实并保密",
    desc: "如实反映、不夸大不编造，尊重他人合法权益，不在网络上公开扩散可能涉及他人隐私的信息。",
  },
  {
    step: "05",
    icon: "ri-phone-fill",
    title: "配合后续核查",
    desc: "如实告知后续核查所需信息，保持联系方式畅通，由相关部门依法依规处理并反馈。",
  },
  {
    step: "06",
    icon: "ri-shield-user-line",
    title: "共建共治共享",
    desc: "以主人翁心态参与基层治理，共同维护安全有序的生活环境，让身边问题得到及时关注。",
  },
];

export const scopeGroups = [
  {
    title: "社区治安类",
    tone: "primary",
    items: ["可疑人员长期逗留", "疑似赌博、传销聚集", "非法改装、危险品存放", "流窜推销与诈骗苗头"],
  },
  {
    title: "公共秩序类",
    tone: "accent",
    items: ["占道经营影响通行", "噪声扰民纠纷", "电动车违规充电隐患", "消防通道被占用"],
  },
  {
    title: "市容环境类",
    tone: "secondary",
    items: ["垃圾乱堆影响环境", "井盖缺失存在隐患", "路灯损坏、道路坑洼", "占绿毁绿行为"],
  },
  {
    title: "政务服务类",
    tone: "primary",
    items: ["公共服务不到位", "政策咨询与求助", "办事流程不清晰", "政务意见与建议"],
  },
];

export const principles = [
  {
    icon: "ri-check-double-line",
    title: "依法有据",
    desc: "一切线索反映都在法律法规框架内进行，通过正规渠道维护自身与公共利益。",
  },
  {
    icon: "ri-user-heart-line",
    title: "客观真实",
    desc: "基于亲眼所见、亲耳所闻的事实进行反映，不臆测、不臆断，杜绝编造与夸大。",
  },
  {
    icon: "ri-hand-heart-line",
    title: "理性友善",
    desc: "尊重每一名公民的合法权益，倡导用沟通、协商与合法途径化解问题。",
  },
  {
    icon: "ri-sparkling-2-line",
    title: "主动担当",
    desc: "人人都可成为平安家园的守望者，通过一点一滴的参与共建和谐社会。",
  },
];

export const testimonials = [
  {
    name: "小区楼长 · 张先生",
    text: "楼道里的消防通道被堆了不少杂物，我向社区反映了情况，网格员很快联系相关部门一起清理，并组织了安全宣传。",
  },
  {
    name: "社区志愿者 · 李阿姨",
    text: "看到有陌生人频繁在小区门口推销可疑产品，我就把情况告诉了民警，经核实及时提醒了大家，避免了上当。",
  },
  {
    name: "上班族 · 陈女士",
    text: "路面井盖破损存在隐患，通过热线反映后转办很快，第二天就围挡处理了。原来身边的小问题真的有人管。",
  },
];

export const faqs = [
  {
    q: "我看到的“可疑情况”是否都应该上报？",
    a: "建议针对确实存在治安隐患、公共安全风险或违法倾向的情况进行反映。先确认基本事实，把握不准时可先向属地社区民警或社区居委咨询，避免因信息不足造成误报。",
  },
  {
    q: "提交线索时会泄露我个人信息吗？",
    a: "通过公安机关与政务等官方渠道反映时，有关部门会依法对反映人信息及线索内容保密。请务必通过正规渠道提交，切勿把个人线索与联系方式随意透露给陌生人或不明网站。",
  },
  {
    q: "什么样的线索属于“信息五要素”？",
    a: "通常指时间、地点、人物、事件经过以及现场情况五类信息。把这五要素尽量说清楚，能帮助核查人员更准确地判断情况并开展后续处理。",
  },
  {
    q: "反映之后一般多久会有反馈？",
    a: "不同问题的处理时效有所不同。涉及紧急治安情况的应拨打报警电话并说明；普通民生与政务类问题按流程转办，一般会有回访或进展说明，你也可以主动跟进。",
  },
  {
    q: "如果遇到紧急危险情况该怎么办？",
    a: "遇到正在发生、正在危害人身或财产安全的紧急情况，应立即拨打报警电话求助并说明具体位置，切勿延误。同时注意保护自身安全，在安全处等待专业人员处置。",
  },
  {
    q: "把情况发到网上“曝光”合适吗？",
    a: "不建议把可能涉及他人隐私或尚未核实的信息直接公开发布。依法、理性地通过官方渠道反映，既保护自己也避免误伤他人，是更稳妥的方式。",
  },
];

export const footerLinks = [
  { label: "反映渠道", href: "#channels" },
  { label: "提供信息指南", href: "#guide" },
  { label: "反映范围", href: "#scope" },
  { label: "常见问题", href: "#faq" },
];

export const navItems = [
  { label: "首页", href: "#home" },
  { label: "反映渠道", href: "#channels" },
  { label: "信息指南", href: "#guide" },
  { label: "反映范围", href: "#scope" },
  { label: "参与原则", href: "#principles" },
  { label: "常见问题", href: "#faq" },
];